import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

/**
 * Displays validation error messages
 */
@Component({
  template: '<div class="esf-form-validation__message" [class.hide]="_hide">{{_text}}</div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./validation-message.component.scss']
 })
 export class ValidationMessageComponent {
  public _text: string;
  public _hide: boolean = true;

  @Input() set text(value: any) {
    if (value !== this._text) {
      this._text = value;
      this._hide = !value;
      this.cdr.detectChanges();
    }
  }

  constructor(private cdr: ChangeDetectorRef) { }
 }
